import { render } from "./PhotosSection.vue?vue&type=template&id=b748e9ca&scoped=true"
import script from "./PhotosSection.vue?vue&type=script&lang=js"
export * from "./PhotosSection.vue?vue&type=script&lang=js"

import "./PhotosSection.vue?vue&type=style&index=0&id=b748e9ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.27_vue@3.5.27_webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b748e9ca"]])

export default __exports__